import { useDataValue, useDataSubmit } from 'Simple/Data.js'
import { isSameDay } from 'date-fns'

export function useOnClick(props) {
  let date = useDataValue({
    context: 'date',
    path: 'date',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'dates',
    viewPath: props.viewPath,
  })

  return function onClick() {
    return submit({ date })
  }
}

/**
 * @param {string} date_date
 * @param {Date} selected_date
 * @returns {boolean}
 */
export function isSelected(date, selectedDate) {
  return isSameDay(date, selectedDate)
}
